import type { ExploreContentItemContentOneOfThreesevenMediaLinksItemProjectInfoEngagementAllOf } from './exploreContentItemContentOneOfThreesevenMediaLinksItemProjectInfoEngagementAllOf';
import type { ExploreContentItemContentOneOfThreesevenMediaLinksItemProjectInfoEngagementAllOfTwo } from './exploreContentItemContentOneOfThreesevenMediaLinksItemProjectInfoEngagementAllOfTwo';

/**
 * 프로젝트 참여 통계
 */
export type ExploreContentItemContentOneOfThreesevenMediaLinksItemProjectInfoEngagement = ExploreContentItemContentOneOfThreesevenMediaLinksItemProjectInfoEngagementAllOf & ExploreContentItemContentOneOfThreesevenMediaLinksItemProjectInfoEngagementAllOfTwo;
